import * as React from "react";
import { toastr } from "react-redux-toastr";
import { AlertsService } from "src/share/services/alerts";
import { IAlert } from "src/share/types/alert";
import { getDaysDifferenceFromToday } from "src/share/utils/utils";

export const useDaysAgo = (alertId: string): returned => {
  const [daysAgo, setDaysAgo] = React.useState<number | null>(null);
  const [error, setError] = React.useState<boolean>(false);
  const loadAlertData = async () => {
    try {
      const alertInfo = await AlertsService.getAlertByID(alertId) as IAlert;
      if (alertInfo && alertInfo.createdAt) {
        const daysDifference = getDaysDifferenceFromToday(alertInfo.createdAt);
        setDaysAgo(daysDifference);
      } else {
        setError(true);
        toastr.error("Error", "There were no records found for this alert Id");
      }
    } catch {
      setError(true);
      toastr.error("Error", "There was an error loading the alert information");
    }
  }
  React.useEffect(() => { loadAlertData() }, []);
  return [daysAgo, error] as returned;
}

type returned = [number | null, boolean]